import { RootState } from '@store/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  FEEDBACK_ALL,
  FEEDBACK_CREATE,
  FEEDBACK_EDIT,
  FEEDBACK_FORM,
  FEEDBACK_FORM_ALL,
  FEEDBACK_FORM_CREATE,
  FEEDBACK_FORM_LIST,
  FEEDBACK_LIST,
  FEEDBACK_TYPES,
  FEEDBACK_UPDATE,
  GLOBAL_STATE,
} from '../constants/actionTypes'

const feedbackSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const feedbackAllSelector = createSelector(feedbackSelector, data => data[FEEDBACK_ALL])

export const feedbackCreateSelector = createSelector(feedbackSelector, data => data[FEEDBACK_CREATE])

export const feedbackEditSelector = createSelector(feedbackSelector, data => data[FEEDBACK_EDIT])

export const feedbackListSelector = createSelector(feedbackSelector, data => data[FEEDBACK_LIST])

export const feedbackTypesSelector = createSelector(feedbackSelector, data => data[FEEDBACK_TYPES])

export const feedbackUpdateSelector = createSelector(feedbackSelector, data => data[FEEDBACK_UPDATE])

export const feedbackFormSelector = createSelector(feedbackSelector, data => data[FEEDBACK_FORM])

export const feedbackFormAllSelector = createSelector(feedbackSelector, data => data[FEEDBACK_FORM_ALL])

export const feedbackFormCreateSelector = createSelector(feedbackSelector, data => data[FEEDBACK_FORM_CREATE])

export const FeedbackFormListSelector = createSelector(feedbackSelector, data => data[FEEDBACK_FORM_LIST])
